import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalStateService {
  // Category state (using localStorage for refresh support)
  private activeCategorySubject = new BehaviorSubject<number | null>(this.getStoredCategory());
  activeCategory$ = this.activeCategorySubject.asObservable();
  
  private activeSelectedCategorySubject = new BehaviorSubject<any>(this.getStoredCategory());
  activeSelectedCategory$ = this.activeSelectedCategorySubject.asObservable();

  private activeSubcategorySubject = new BehaviorSubject<number | null>(this.getStoredSubcategory());
  activeSubcategory$ = this.activeSubcategorySubject.asObservable();

  // Product ID state (no localStorage to avoid stale data)
  private selectedProductIdSubject = new BehaviorSubject<number | null>(null);
  selectedProductId$ = this.selectedProductIdSubject.asObservable();

  // Header/footer visibility
  headerVisibleSubject = new BehaviorSubject<boolean>(true);
  footerVisibleSubject = new BehaviorSubject<boolean>(true);

  // Selected product object
  private selectedProductSubject = new BehaviorSubject<any | null>(null);
  selectedProduct$ = this.selectedProductSubject.asObservable();

  // Category methods
  setActiveCategory(categoryId: number | null): void {
    this.activeCategorySubject.next(categoryId);
    localStorage.setItem('activeCategory', categoryId?.toString() ?? '');
  }
  setSeletedActiveCategory(category: any): void {
    this.activeSelectedCategorySubject.next(category);
    localStorage.setItem('activeSeletedCategory', JSON.stringify(category) ?? '');
  }

  setActiveSubcategory(subcategoryId: number | null): void {
    this.activeSubcategorySubject.next(subcategoryId);
    localStorage.setItem('activeSubcategory', subcategoryId?.toString() ?? '');
  }

  clearActiveCategory(): void {
    // this.activeCategorySubject.next(-1); // or just skip this if not needed
    localStorage.removeItem('activeCategory');
    localStorage.removeItem('cat_id');
    localStorage.removeItem('header_cId');
  }


  clearActiveSubcategory(): void {
    this.activeSubcategorySubject.next(null);
    localStorage.removeItem('activeSubcategory');
  }

  getStoredCategory(): number | null {
    const value = localStorage.getItem('activeCategory');
    return value ? +value : null;
  }

  getStoredSubcategory(): number | null {
    const value = localStorage.getItem('activeSubcategory');
    return value ? +value : null;
  }

  // Product ID methods
  setSelectedProductId(id: number | null): void {
    this.selectedProductIdSubject.next(id);
  }

  clearSelectedProductId(): void {
    this.selectedProductIdSubject.next(null);
  }

  getSelectedProductId(): number | null {
    return this.selectedProductIdSubject.getValue();
  }

  // Selected product object methods
  setSelectedProduct(product: any): void {
    this.selectedProductSubject.next(product);
  }

  getSelectedProduct(): any | null {
    return this.selectedProductSubject.getValue();
  }

  clearSelectedProduct(): void {
    this.selectedProductSubject.next(null);
  }

  // Header/footer visibility
  updateHeaderAndFooterVisibility(state: boolean): void {
    this.headerVisibleSubject.next(state);
    this.footerVisibleSubject.next(state);
  }
}